import { VStack } from '@chakra-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';

import GoalCategory from './GoalCategory';
import Goals from './Goals';

const MyBox = ({ category }) => {
  const { archived } = useSelector(state => state.goals);

  return (
    <VStack w={'full'} spacing={4} h={'300px'} px={6}>
      <GoalCategory category={category} />

      {archived
        ? category.archived_goals.length > 0 && (
              <Goals goals={category.archived_goals} category={category} />
            )
        : category.goals.length > 0 && (
            <Goals goals={category.goals} category={category} />
          )}
    </VStack>
  );
};

export default MyBox;
